import React, { ComponentProps, PropsWithChildren } from 'react';
import styles from './IconChecklist.module.scss';
import { GrowItem, Inline, Stack } from 'components/layout';
import { Icon, IconList } from 'components/core';

export const IconChecklist = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Stack spacing={3} component="ul" className={styles.checklist}>
      {children}
    </Stack>
  );
};

type ItemProps = PropsWithChildren<{
  iconVariant?: ComponentProps<typeof Icon>['variant'];
  alignY?: 'top' | 'center';
}>;

export const IconChecklistItem = ({
  children,
  iconVariant = 'primary',
  alignY = 'top',
}: ItemProps) => {
  return (
    <Inline
      spacing={2}
      alignX="left"
      alignY={alignY}
      shouldWrap={false}
      component="li"
    >
      <Icon
        size="xl"
        variant={iconVariant}
        icon={IconList.solid.faCircleCheck}
      />
      <GrowItem>{children}</GrowItem>
    </Inline>
  );
};
